module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_pict02_pc01-f46f69fa0e2575ad026bcb5570222513.webp";